
export const getGiftProducts = (state) => {
  const { giftProducts } = state.gifts;
  if (giftProducts) return giftProducts;
  return null;
};

export const getSelectedGiftProduct = (state) => {
  const { selectedProduct } = state.gifts;
  if (selectedProduct) return selectedProduct;
  return null;
};
